import { render } from "./OurSpirit.vue?vue&type=template&id=5dbf3840"
import script from "./OurSpirit.vue?vue&type=script&lang=js"
export * from "./OurSpirit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__